var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramTools64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./Tools64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram",
    transform: "translate(8.000000, 8.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Focus",
    fill: "#FFCC00",
    x: 24,
    y: 24,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,1 L24,47",
    id: "LineVert",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,24 L47,24",
    id: "LineHorz",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    id: "+",
    transform: "translate(7.000000, 7.000000)",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5 L10,5",
    id: "LineHorz"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,0 L5,10",
    id: "LineVert"
  })), /*#__PURE__*/React.createElement("g", {
    id: "-",
    transform: "translate(31.000000, 11.000000)",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1 L10,1",
    id: "LineHorz"
  })), /*#__PURE__*/React.createElement("g", {
    id: "x",
    transform: "translate(8.000000, 32.000000)",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,8 L8,-7.10542736e-15",
    id: "LineDiagR"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L8,8",
    id: "LineDiagL"
  })), /*#__PURE__*/React.createElement("g", {
    id: "=",
    transform: "translate(31.000000, 32.000000)",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1 L10,1",
    id: "LineHorz"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7 L10,7",
    id: "LineHorz"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramTools64);
export default __webpack_public_path__ + "static/media/pictogramTools64.ecf938c7bac4dbb82f5a78110e97d0cd.svg";
export { ForwardRef as ReactComponent };